<template>
    <div class="animated fadeIn">
        <div>
            <b-row v-if="loading">
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading">
            <b-row>
                <b-col>
                    <h3>Partner Report</h3>
                </b-col>
            </b-row>
            <b-card>
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <h3 class="head-text">Partner Dashboard</h3>
                            </b-col>
                        </b-row>
                        <b-card-group deck>
                            <b-card class="total-order-header">
                                <template #header>
                                    <div class="d-flex justify-content-between">
                                        <h4 class="text-white">
                                            Total Partner
                                        </h4>
                                        <h3 class="text-white text-right">
                                            {{ totalPartner }}
                                        </h3>
                                    </div>
                                </template>
                                <div class="row">
                                    <h4 class="col-md-8 pt-0 pb-0">
                                        Active Partners
                                    </h4>
                                    <h4 class="col-md-4 pt-0 pb-0 text-right">
                                        {{ activePartners }}
                                    </h4>
                                </div>
                                <div class="row">
                                    <h4 class="col-md-8 pt-0 pb-0">
                                        Inactive Partners
                                    </h4>
                                    <h4 class="col-md-4 pt-0 pb-0 text-right">
                                        {{ inactivePartners }}
                                    </h4>
                                </div>
                                <div class="row">
                                    <h4 class="col-md-8 pt-0 pb-0">
                                        Low Balance Partner
                                    </h4>
                                    <h4 class="col-md-4 pt-0 pb-0 text-right">
                                        {{ lowBalancePartner }}
                                    </h4>
                                </div>
                                <div class="row">
                                    <h4 class="col-md-8 pt-0 pb-0">
                                        Partner breached item count
                                    </h4>
                                    <h4 class="col-md-4 pt-0 pb-0 text-right">
                                        {{ breachedItemCount }}
                                    </h4>
                                </div>
                            </b-card>
                        </b-card-group>
                    </b-col>
                </b-row>
            </b-card>

            <b-card>
                <b-row
                    ><b-col md="4">
                        <h4 class="ml-2">Top 10 Performers</h4>
                    </b-col>
                    <b-col md="2">
                        <a href="#" class="right">
                            <img
                                src="@/assets/images/DataExport.png"
                                class="upload-btn"
                                alt="data export"
                            />
                        </a>
                    </b-col>
                    <!-- <b-col md="3">
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="performer"
            v-model="selectPerformer"
            placeholder="Top 10 Performer"
            @input="changePerformer"
          >
          </eb-select>
        </b-col> -->
                    <b-col md="3">
                        <eb-select
                            style="background-color: #fff"
                            id="text"
                            type="text"
                            label="text"
                            :options="orderOption"
                            v-model="selectOrderOption"
                            placeholder="By Order Count"
                            :selected="selectOrderOption.text"
                            @input="changeOrderOption"
                        >
                        </eb-select>
                    </b-col>
                    <b-col md="3">
                        <eb-select
                            ref="dateRef"
                            style="background-color: #fff"
                            id="text"
                            type="text"
                            label="text"
                            :options="dateOption"
                            v-model="selectedDate"
                            :selected="selectedDate.text"
                            @input="changeDate"
                        >
                        </eb-select>
                        <c-date
                            ref="compRefs"
                            modalRef="modalRef"
                            modalId="dateModal"
                            @customDateRange="findDateResult"
                        ></c-date> </b-col
                ></b-row>
                <b-table
                    :dark="false"
                    :items="items"
                    :hover="true"
                    striped
                    bordered
                    small
                    fixed
                    responsive="sm"
                    id="my-table"
                    thead-class="header"
                    class="mt-3"
                    show-empty
                    :no-border-collapse="true"
                ></b-table>
            </b-card>

            <!-- <b-card
      ><b-row
        ><b-col md="9"> <h4>Partner By Mode</h4> </b-col
        ><b-col>
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="dateOption1"
            v-model="selectedDate1"
            :selected="selectedDate1.text"
            @input="changeDate1"
          >
          </eb-select>
          <b-modal
            title="Select Date"
            header-class="header-nipige-class"
            id="dateRange"
            size="sm"
            ref="date-range"
            centered
            hide-footer
          >
            <b-input class="mb-2" type="date" v-model="startDate1"></b-input>
            <b-input type="date" v-model="endDate1"></b-input>
            <div class="text-center mt-2">
              <b-button
                @click="findButtonClick1()"
                class="my -0 main-navigation-button w-47 mr-2"
                variant="success"
                >Find
              </b-button>
            </div>
          </b-modal>
        </b-col></b-row
      >
      <BarChart :chart-data="chartData" :chart-options="barChartOptions" />
    </b-card> -->

            <b-card>
                <b-row
                    ><b-col md="4">
                        <h4 class="ml-2">Top 10 Performer</h4>
                    </b-col>
                    <b-col md="2">
                        <a href="#" class="right">
                            <img
                                src="@/assets/images/DataExport.png"
                                class="upload-btn"
                                alt="data export"
                            />
                        </a>
                    </b-col>
                    <b-col md="3">
                        <eb-select
                            style="background-color: #fff"
                            id="text"
                            type="text"
                            label="text"
                            :options="baseOptions"
                            v-model="selectedBase"
                            placeholder="Market Wise"
                            @input="changeBaseFilter"
                        >
                        </eb-select>
                    </b-col>

                    <b-col md="3">
                        <eb-select
                            ref="dateRef1"
                            style="background-color: #fff"
                            id="text"
                            type="text"
                            label="text"
                            :options="dateOption1"
                            v-model="selectedDate1"
                            :selected="selectedDate1.text"
                            @input="changeDate1"
                        >
                        </eb-select>
                        <c-date
                            ref="compRefs1"
                            modalRef="modalRef1"
                            modalId="dateModal1"
                            @customDateRange="findDateResult1"
                        ></c-date> </b-col
                ></b-row>
                <BarChart
                    :chart-data="marketWiseBarChart"
                    :chart-options="barChartOptions"
                />
            </b-card>

            <!-- <b-card>
      <b-row
        ><b-col md="4">
          <h4 class="ml-2">Low Balance Partner Report</h4>
        </b-col>
        <b-col md="2">
          <a href="#" class="text-right">
            <img
              src="@/assets/images/DataExport.png"
              class="upload-btn"
              alt="data export"
            />
          </a>
        </b-col>
        <b-col md="3">
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="performer"
            v-model="selectPerformer"
            placeholder="Low Balance Partner"
            @input="changePerformer"
          >
          </eb-select>
        </b-col>
        <b-col>
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="dateOption"
            v-model="selectedDate1"
            :selected="selectedDate1.text"
            @input="changeDate1"
          >
          </eb-select>
          <b-modal
            title="Select Date"
            header-class="header-nipige-class"
            id="dateRange"
            size="sm"
            ref="date-range"
            centered
            hide-footer
          >
            <b-input class="mb-2" type="date" v-model="startDate"></b-input>
            <b-input type="date" v-model="endDate"></b-input>
            <div class="text-center mt-2">
              <b-button
                @click="findButtonClick()"
                class="my -0 main-navigation-button w-47 mr-2"
                variant="success"
                >Find
              </b-button>
            </div>
          </b-modal>
        </b-col></b-row
      >
      <b-table
        :dark="false"
        :items="items1"
        :hover="true"
        striped
        bordered
        small
        fixed
        responsive="sm"
        id="my-table"
        :current-page="currentpage1"
        :per-page="perPage1"
        thead-class="header"
        class="mt-3"
        show-empty
        :fields="Columns1"
        :no-border-collapse="true"
        @filtered="onfilter1"
      ></b-table>
      <b-pagination
        style="float: right"
        v-model="currentPage1"
        :total-rows="filterCount1"
        :per-page="perPage1"
        prev-text="Prev"
        next-text="Next"
        aria-controls="myHistory"
        hide-goto-end-buttons
      ></b-pagination>
    </b-card> -->
        </div>
    </div>
</template>
<script>
import marketWiseChart from "@/utils/marketWiseChart";
import ComponentHeader from "@/components/componentNewHeader";
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import BarChart from "@/components/chart/BarChart";
import paymentChart from "@/utils/paymentChart";
import cDate from "@/components/FormElements/CustomDate.vue";
import { AtomSpinner } from "epic-spinners";

export default {
    name: "Reports",
    components: {
        ComponentHeader,
        ebSelect,
        evSelect,
        BarChart,
        cDate,
        AtomSpinner,
    },
    data() {
        return {
            prevSelectedDate: null,
            prevSelectedDate1: null,
            loading: false,
            activePartners: 0,
            totalPartner: 0,
            inactivePartners: 0,
            lowBalancePartner: 0,
            breachedItemCount: 0,
            filterCount: 1,
            filterCount1: 1,
            currentpage: 1,
            currentpage1: 1,
            Columns: [
                {
                    key: "partnerName",
                },
                {
                    key: "orderCount",
                },
                {
                    key: "orderValue",
                },
                {
                    key: "rank",
                },
            ],
            Columns1: [
                {
                    key: "partnerName",
                },
                {
                    key: "category",
                },
                {
                    key: "itemCount",
                },
                {
                    key: "commission",
                    label: "Commission %",
                },
            ],
            // items: [],
            items1: [],
            currentPage: 1,
            perPage: 9,
            currentPage1: 1,
            perPage1: 9,
            performer: [],
            selectPerformer: "",
            selectOrderOption: {
                text: "By Order Count",
                value: "By Order Count",
            },
            orderOption: [
                {
                    text: "By Order Count",
                    value: "By Order Count",
                },
                {
                    text: "By Order Value",
                    value: "By Order Value",
                },
            ],
            selectedDate: {
                text: "Today",
                value: 0,
            },
            dateOption: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 day's",
                    value: 6,
                },
                {
                    text: "30 day's",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate: "",
            endDate: "",
            startDate1: "",
            endDate1: "",
            performerFilter: "top10performer-byorder",
            marketCityFilter: "total-marketwish-partner-graph",
            selectedBase: {
                text: "Market Wise",
                value: "Market Wise",
            },
            baseOptions: [
                {
                    text: "Market Wise",
                    value: "Market Wise",
                },
                {
                    text: "City Wise",
                    value: "City Wise",
                },
            ],
            selectedDate1: {
                text: "Today",
                value: 0,
            },
            dateOption1: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 day's",
                    value: 6,
                },
                {
                    text: "30 day's",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate1: "",
            endDate1: "",
            barChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                    },
                },
            },
        };
    },
    computed: {
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        chartData() {
            let data = this.$store.getters["partner/getChartData"];
            let Partnerkey = "";
            let PartnerMode = "";
            let PartnerAmount = "";
            let date = "";
            if (this.$currentUserData.category == "TA") {
                Partnerkey = "orderbyPartnertype-graph";
                PartnerAmount = "count";
                PartnerMode = "Partner";
                date = "date";
            } else if (this.$currentUserData.category === "SELLER") {
                Partnerkey = "seller-orderbyPartnertype-graph";
                PartnerAmount = "ordercount";
                date = "date";
                PartnerMode = "Partnertype";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                Partnerkey = "subdealer-orderbyPartnertype-graph";
                PartnerAmount = "ordercount";
                date = "date";
                PartnerMode = "Partnertype";
            }
            const PartnerList = data[Partnerkey];
            return paymentChart(PartnerList, PartnerAmount, date, PartnerMode);
        },
        chartData1() {
            let data = this.$store.getters["partner/GetBulkAnalyticsRept"];
            let dailyRegistrationKey = "";
            let registrationCount = "";
            let dayCount = "";
            if (this.$currentUserData.category == "TA") {
                dailyRegistrationKey = "daily-registration-graph";
                registrationCount = "count";
                dayCount = "day";
            } else if (this.$currentUserData.category === "SELLER") {
                dailyRegistrationKey = "seller-daily-registration-graph";
                registrationCount = "count";
                dayCount = "day";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                dailyRegistrationKey = "subdealer-daily-registration-graph";
                registrationCount = "count";
                dayCount = "day";
            }
            const dailyRegistration = data[dailyRegistrationKey];
            return marketWiseChart(
                dailyRegistration,
                registrationCount,
                dayCount,
            );
        },
        marketWiseBarChart() {
            let data =
                this.$store.getters["partner/GetMarketWisePerformerData"];
            const labels = [];
            const datasets = [
                {
                    label: "Partner Count",
                    fill: true,
                    borderColor: "#0b91ba",
                    backgroundColor: "#0b91ba",
                    pointBorderColor: "#0b91ba",
                    borderWidth: 3,
                    yAxisID: "y",
                    data: [],
                },
            ];
            if (data && data["admin-total-citywish-partner-graph"]) {
                if (data["admin-total-citywish-partner-graph"].length > 0) {
                    data["admin-total-citywish-partner-graph"].map((x) => {
                        labels.push(x.city);
                        datasets[0].data.push(
                            +parseFloat(x.total_number).toFixed(2),
                        );
                    });
                }
            }
            if (data && data["admin-total-marketwish-partner-graph"]) {
                if (data["admin-total-marketwish-partner-graph"].length > 0) {
                    data["admin-total-marketwish-partner-graph"].map((x) => {
                        labels.push(x.market);
                        datasets[0].data.push(
                            +parseFloat(x.provider).toFixed(2),
                        );
                    });
                }
            }
            return {
                labels,
                datasets,
            };
        },
        items() {
            const data = this.$store.getters["partner/GetTop10PerformerData"];
            return data[this.performerFilter] || [];
        },
    },

    methods: {
        onfilter(list) {
            this.filtercount = list.length;
            this.currentpage = 1;
        },
        onfilter1(list) {
            this.filtercount1 = list.length;
            this.currentpage1 = 1;
        },
        async getAnalyticsData() {
            if (this.$currentUserData.category === "TA") {
                const payload = {
                    items: [
                        {
                            key: "daily-registration-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                tenant: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
            } else if (this.$currentUserData.category === "SELLER") {
                const payload = {
                    items: [
                        {
                            key: "seller-daily-registration-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                const payload = {
                    items: [
                        {
                            key: "subdealer-daily-registration-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
            }
        },
        changePerformer() {
            //
        },
        changeOrderOption() {
            if (this.selectOrderOption.text === "By Order Count") {
                this.performerFilter = "top10performer-byorder";
            }
           else {
                //     this.performerFilter = "top10performer-byvalue";
                this.performerFilter = "admin-top10performer-byvalue";
                 }
            this.fetchPerformerReport();
        },
        async fetchPerformerReport() {
            if (this.$currentUserData.role === "Admin") {
                const payload = {
                    items: [
                        {
                            key: this.performerFilter,
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                limit: 10,
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchTop10Performer",
                    payload,
                );
            } else if (this.$currentUserData.category === "TA") {
                const payload = {
                    items: [
                        {
                            key: this.performerFilter,
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                tenant: this.userId,
                                limit: 10,
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchTop10Performer",
                    payload,
                );
            }
        },
        changeBaseFilter() {
            if (this.selectedBase.text === "Market Wise") {
                this.marketCityFilter = "admin-total-marketwish-partner-graph";
            } else {
                this.marketCityFilter = "admin-total-citywish-partner-graph";
            }
            this.fetchMarketCityPerformers();
        },
        async fetchMarketCityPerformers() {
            if (this.$currentUserData.role === "Admin") {
                const payload = {
                    items: [
                        {
                            key: this.marketCityFilter,
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchMarketWisePerformer",
                    payload,
                );
            } else if (this.$currentUserData.category === "TA") {
                const payload = {
                    items: [
                        {
                            key: this.marketCityFilter,
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                tenant: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchMarketWisePerformer",
                    payload,
                );
            }
        },
        findDateResult1(e) {
            ((this.startDate1 = e.fromDate),
                (this.endDate1 = e.toDate),
                this.fetchMarketCityPerformers());
            // Market wise performer
        },
        changeDate1(e) {
            if (e.value === "custom") {
                this.prevSelectedDate1 = { ...this.selectedDate1 };
                this.selectedDate1 = this.prevSelectedDate1;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].close
                    ) {
                        this.$refs["dateRef1"].close();
                    } else if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].$el
                    ) {
                        const el =
                            this.$refs["dateRef1"].$el.querySelector("input") ||
                            this.$refs["dateRef1"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs1"].openModal();
                });
            } else {
                this.fetchMarketCityPerformers();
            }
        },
        getDateData1(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate1,
                    toDate: this.endDate1,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async dashboardReport() {
            this.loading = true;

            if (this.$currentUserData.role === "Admin") {
                const dateVars = this.fixedDate();

                const payload = {
                    items: [
                        {
                            key: "admin-total-partners",
                            variables: dateVars,
                        },
                        {
                            key: "admin-active-partners",
                            variables: dateVars,
                        },
                        {
                            key: "admin-inactive-partners",
                            variables: dateVars,
                        },
                        {
                            key: "admin-low-balance-partner-report",
                            variables: dateVars,
                        },
                        {
                            key: "admin-total-item-volume-breached",
                            variables: dateVars,
                        },
                    ],
                };

                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
                this.activePartners =
                    data["admin-active-partners"] &&
                    data["admin-active-partners"].count
                        ? data["admin-active-partners"].count
                        : 0;

                this.totalPartner =
                    data["admin-total-partners"] &&
                    data["admin-total-partners"][0] &&
                    data["admin-total-partners"][0].count
                        ? +data["admin-total-partners"][0].count
                        : 0;

                this.inactivePartners =
                    data["admin-inactive-partners"] &&
                    data["admin-inactive-partners"].count
                        ? data["admin-inactive-partners"].count
                        : 0;

                this.lowBalancePartner =
                    data["admin-low-balance-partner-report"] &&
                    data["admin-low-balance-partner-report"][0] &&
                    data["admin-low-balance-partner-report"][0].count
                        ? data["admin-low-balance-partner-report"][0].count
                        : 0;

                this.breachedItemCount =
                    data["admin-total-item-volume-breached"] &&
                    data["admin-total-item-volume-breached"][0] &&
                    data["admin-total-item-volume-breached"][0].count
                        ? data["admin-total-item-volume-breached"][0].count
                        : 0;
            } else if (this.$currentUserData.category === "TA") {
                const payload = {
                    items: [
                        {
                            key: "total-partners",
                            variables: {
                                ...this.fixedDate(),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "active-partners",
                            variables: {
                                ...this.fixedDate(),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "inactive-partners",
                            variables: {
                                ...this.fixedDate(),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "low-balance-partner-report",
                            variables: {
                                ...this.fixedDate(),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "total-item-volume-breached",
                            variables: {
                                // ...this.fixedDate(),
                                tenant: this.userId,
                            },
                        },
                    ],
                };
                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
                this.activePartners = data["active-partners"]?.count || 0;
                this.totalPartner = +data["total-partners"][0]?.count || 0;
                this.inactivePartners = data["inactive-partners"].count || 0;
                this.lowBalancePartner =
                    data["low-balance-partner-report"][0]?.count || 0;
                this.breachedItemCount =
                    data["total-item-volume-breached"][0]?.count || 0;
                // const payload1 = {
                //   items: [
                //     {
                //       key: "total-orders",
                //       variables: {
                //         fromDate: this.getProperDate1(
                //           moment().startOf("month").toISOString()
                //         ),
                //         toDate: this.getProperDate1(
                //           moment()
                //             .add(+1, "days")
                //             .toDate()
                //             .toISOString()
                //         ),
                //         tenant: this.userId,
                //       },
                //     },
                //   ],
                // };
                // const data1 = await this.$store.dispatch(
                //   "partner/fetchBulkAnalyticReport",
                //   payload1
                // );
                // this.totalPartnerMonth = (
                //   +data1["total-orders"]?.total_order_amount || 0
                // ).toFixed(2);
            } else if (this.$currentUserData.category === "SELLER") {
                const payload = {
                    items: [
                        {
                            key: "seller-total-orders",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-total-collected",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-pending-collection",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-total-refunded",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-total-Partner-cancelled",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
                this.activePartners =
                    data["seller-total-collected"].activePartners || 0;
                this.totalPartner = (
                    +data["seller-total-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.totalFailed =
                    data["seller-total-Partner-cancelled"].total_collected || 0;
                this.totalRefunded =
                    data["seller-total-refunded"].total_collected || 0;
                this.totalPendingAmount =
                    data["seller-pending-collection"].total_collected || 0;
                const payload1 = {
                    items: [
                        {
                            key: "seller-total-orders",
                            variables: {
                                fromDate: this.getProperDate1(
                                    moment().startOf("month").toISOString(),
                                ),
                                toDate: this.getProperDate1(
                                    moment()
                                        .add(+1, "days")
                                        .toDate()
                                        .toISOString(),
                                ),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                const data1 = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload1,
                );
                this.totalPartnerMonth = (
                    +data1["seller-total-orders"].total_order_amount || 0
                ).toFixed(2);
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                const payload = {
                    items: [
                        {
                            key: "subdealer-total-orders",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-total-collected",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-pending-collection",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-total-refunded",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-total-Partner-cancelled",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
                this.activePartners =
                    data["subdealer-total-collected"].total_collected || 0;
                this.totalPartner = (
                    +data["subdealer-total-orders"].total_order_amount || 0
                ).toFixed(2);
                this.totalFailed =
                    data["subdealer-total-Partner-cancelled"].total_collected ||
                    0;
                this.totalRefunded =
                    data["subdealer-total-refunded"].total_collected || 0;
                this.totalPendingAmount =
                    data["subdealer-pending-collection"].total_collected || 0;
                const payload1 = {
                    items: [
                        {
                            key: "subdealer-total-orders",
                            variables: {
                                fromDate: this.getProperDate1(
                                    moment().startOf("month").toISOString(),
                                ),
                                toDate: this.getProperDate1(
                                    moment()
                                        .add(+1, "days")
                                        .toDate()
                                        .toISOString(),
                                ),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                const data1 = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload1,
                );
                this.totalPartnerMonth = (
                    +data1["subdealer-total-orders"]?.total_order_amount || 0
                ).toFixed(2);
            }
            this.loading = false;
        },
        getProperDate1(data) {
            if (data != null) {
                let date = new Date(data);
                return moment(String(date)).format("YYYY-MM-DD");
            } else return "Unavailable";
        },
        fixedDate() {
            let date = new Date();
            let today = moment(String(date)).format("YYYY-MM-DD");
            let dateObj = {
                fromDate: "1990-01-01",
                toDate: today,
            };
            return dateObj;
        },
        findDateResult(e) {
            ((this.startDate = e.fromDate),
                (this.endDate = e.toDate),
                // this.fetchPartnerChart();
                this.fetchPerformerReport());
        },
        changeDate(e) {
            if (e.value === "custom") {
                // Save previous selection
                this.prevSelectedDate = { ...this.selectedDate };
                this.selectedDate = this.prevSelectedDate;

                // Close dropdown & open modal
                this.$nextTick(() => {
                    if (this.$refs["dateRef"] && this.$refs["dateRef"].close) {
                        this.$refs["dateRef"].close();
                    } else if (
                        this.$refs["dateRef"] &&
                        this.$refs["dateRef"].$el
                    ) {
                        const el =
                            this.$refs["dateRef"].$el.querySelector("input") ||
                            this.$refs["dateRef"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs"].openModal();
                });
            } else {
                // Non-custom -> directly fetch
                this.fetchPerformerReport();
            }
        },

        findDateResult(e) {
            // Ensure both dates are captured
            this.startDate = e.fromDate;
            this.endDate = e.toDate;

            // Now trigger API with these values
            this.selectedDate.value = "custom"; // mark as custom
            this.fetchPerformerReport();
        },

        getDateData(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
                return data;
            }
            if (dateData == 0) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(0, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(29, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchPartnerChart() {
            if (this.$currentUserData.category === "TA") {
                const payload = {
                    items: [
                        {
                            key: "orderbyPartnertype-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                tenant: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchChart", payload);
            } else if (this.$currentUserData.category === "SELLER") {
                const payload = {
                    items: [
                        {
                            key: "seller-orderbyPartnertype-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                tenant: this.$currentUserData.tenant,
                                userId: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchChart", payload);
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                const payload = {
                    items: [
                        {
                            key: "subdealer-orderbyPartnertype-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                tenant: this.$currentUserData.tenant,
                                userId: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchChart", payload);
            }
        },
    },
    mounted() {
        this.dashboardReport();
        this.fetchPerformerReport();
        this.fetchMarketCityPerformers();
    },
};
</script>
<style scoped>
.head-text {
    margin-bottom: 0px;
    font-size: 1.125rem;
    font-weight: 600;
    color: #000000;
}
.green-chart-icon i {
    background: #def6ee;
    text-align: center;
    color: #65d27d;
    border-radius: 5px;
    font-size: 16px !important;
    height: 36px;
    width: 36px;
    line-height: 36px;
}

.order-price-heading {
    line-break: anywhere;
    line-height: 24px;
}

.total-order-header .card-header {
    background: var(--primary);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.upload-btn {
    height: 39px;
}
</style>
